module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_3-1.c8ad7e29.svg";